<template>
  <div class="container" id="goods-edit">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item>
          <div class="div1">订单管理</div>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <div class="div2">物流订单</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <h2 v-if="type == 0">原订单拆单</h2>
      <h2 v-if="type == 1">母订单拆单</h2>
      <div style="display:flex;justify-content:space-between">
        <div style="line-height:36px">订单商品
          <span style="color: #4168E7;margin-left: 12px;font-size: 14px;">订单编号（{{ orderNo }}）</span>
          <span style="color: #4168E7;margin-left: 12px;font-size: 14px;">代收金额￥{{ totalAmount }}</span>
        </div>
        <div class="aBtn" @click="add">增加拆单</div>
      </div>
      <el-table border :data="goods" :header-cell-style="{
        background: '#F5F6FA',

        color: '#303033',
      }" style="width: 100%;margin-top:20px;">
        <el-table-column label="商品" prop="type" align="left">
          <template slot="header">
            <div style="display: flex">
              <div style="text-align: left">商品</div>
            </div>
          </template>
          <template slot-scope="props">
            <div style="display:flex">
              <div><img style="width:106px;height:80px" :src="props.row.goodsImg" /></div>
              <div>
                <div
                  style="margin-left:8px;font-size: 14px;font-family: PingFang SC;font-weight: bold;line-height: 22px;color: #333333;">
                  {{ props.row.originGoodsName }}</div>
              </div>

            </div>

          </template>
        </el-table-column>
        <el-table-column label="商品规格" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center">{{ props.row.goodsSkuName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center">{{ props.row.quantity }}</div>
          </template>
        </el-table-column>
        <el-table-column label="拆单已选" prop="type" align="center">
          <template slot-scope="props">
            <div style="text-align: center;">{{ props.row.splitQuantity }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-for="(item, index) in splitOrderList" :key="index" style="margin-top:10px">
        <div style="display:flex;justify-content:space-between">
          <div style="display: flex;">
            <div
              style="width: 16px;height: 16px;background: #4168E7;border-radius: 50%;opacity: 1;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 16px;color: #FFFFFF;text-align: center;margin-top: 12px;">
              {{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;">拆单订单{{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;color: #4168E7;font-size: 14px;" v-if="type == 0">
              母订单编号：{{ orderNo }}X{{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;color: #4168E7;font-size: 14px;"
              v-if="type == 1 && index + 1 < 10">
              子订单编号：{{ orderNo }}-0{{ index + 1 }}</div>
            <div style="line-height: 40px;margin-left: 2px;color: #4168E7;font-size: 14px;"
              v-if="type == 1 && index + 1 > 10">
              子订单编号：{{ orderNo }}-{{
                index
                + 1 }}</div>
            <div class="splitType" v-if="type == 0">
              拆单类型：母单</div>
          </div>

          <div style="display: flex;">
            <div v-if="type == 0"
              style="margin-left: 12px;font-size: 14px;font-family: PingFang SC;font-weight: 400;line-height: 40px;color: #333333;">
              代收金额
            </div>
            <div v-if="type == 0" style="margin-left: 12px;margin-top: 6px;"><el-input v-model="item.collectAmount"
                placeholder="请输入代收金额" size="mini"></el-input></div>
            <div style="margin-left: 12px;margin-top: 4px;"><el-button @click="deleteOrder(index)"
                style="color:red;border: 1px solid red;width:90px;height: 28px;line-height: 10px;margin-top: 2px;" plain
                size="small">删除</el-button>
            </div>
          </div>
        </div>

        <el-table border :data="item.goodsList" :header-cell-style="{
          background: '#FAFAFA',

          color: '#303033',
        }" style="width: 100%;margin-top: 10px;">
          <el-table-column label="商品" prop="type" align="left">
            <template slot="header">
              <div style="display: flex">
                <div style="text-align: left">商品</div>
              </div>
            </template>
            <template slot-scope="props">
              <div style="display:flex;width:100%">
                <div><img style="width:106px;height:80px" :src="props.row.goodsImg" /></div>
                <div style="margin-left:12px;flex:1">
                  <div>
                    <el-input type="textarea" :rows="3" v-model="props.row.goodsName" style="height: 80px;"></el-input>
                    <!-- <div style="text-align: left;line-height: 20px;margin-top: 5px;">规格101</div> -->
                  </div>

                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column label="商品规格" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center">{{ props.row.goodsSkuName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center"><el-input v-model="props.row.quantity" style="width:224px" size="small"
                  oninput="value=value.replace(/^0|[^0-9]/g, '')"
                  @change="upDateNum($event, index, props.$index, props.row)" placeholder="请输入数量"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="type" align="center">
            <!-- <template slot="header">
              <div style="display: flex">
                <div style="text-align: center">操作 </div>
              </div>
            </template> -->
            <template slot-scope="props">
              <div>
                <span style="color:#4168E7;cursor: pointer;" @click="deleteD(index, props.$index)">删除</span>
              </div>

            </template>
          </el-table-column>
        </el-table>
        <div class="aBtn" style="margin-top: 16px;" @click="addShop(index)">增加商品</div>
      </div>
      <div style="height: 20px;"></div>
    </div>
    <div style="display: flex;justify-content: start;margin-top: 20px;margin-bottom: 20px;padding-bottom:20px">
      <div class="cBtn1" @click="back">取消</div>
      <div class="qBtn" @click="submit()">确认</div>
    </div>
    <el-dialog title="选择商品" :visible.sync="dialogTableVisible" append-to-body width="640px" :close-on-click-modal="false">
      <div style="padding:20px 30px">
        <el-table border :data="selectGoods" :header-cell-style="{
          background: '#FAFAFA',

          color: '#303033',
        }" style="width: 100%;margin-top: 10px;">
          <el-table-column label="商品名称" prop="type" align="left">
            <template slot="header">
              <div style="display: flex">
                <div style="text-align: left">商品名称</div>
              </div>
            </template>
            <template slot-scope="props">
              <div>{{ props.row.originGoodsName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="商品规格" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center">{{ props.row.goodsSkuName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="剩余数量" prop="type" align="center">
            <template slot-scope="props">
              {{ props.row.quantity }}
            </template>
          </el-table-column>
          <el-table-column label="选择拆单数量" prop="type" align="center">
            <template slot-scope="props">
              <div style="text-align: center"><el-input v-model="props.row.splitQuantity" style="width:100%" size="small"
                  oninput="value=value.replace(/^0|[^0-9]/g, '')" @change="inputNum($event, props.$index, props.row)"
                  placeholder="请输入数量"></el-input></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="type" align="center">
            <template slot-scope="props">
              <el-checkbox v-model="props.row.checked"></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width:100%;height: 0px;border: 1px solid #D9D9D9;"></div>
      <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;margin-right: 30px;">
        <div class="cBtn" @click="dialogTableVisible = false">取消</div>
        <div class="qBtn" @click="save()">确定</div>
      </div>

    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isFinish" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span
          style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">温馨提示</span>
      </div>
      <div class="content" style="padding:20px 30px">
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;" v-if="isContent">订单未完成拆单，请继续拆单！</div>
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;" v-if="!isContent">拆单订单填写的<span
            style="color:red">[代收金额]</span>总和不等于原订单，请修改填写!</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isFinish = false">取消</div>
          <div class="qBtn" @click="isFinish = false">确定</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="删除拆单" :visible.sync="isDelete" width="30%" :append-to-body="true">
      <div slot="title" class="dialog-title">
        <i class="el-icon-warning" style="font-size: 22px;color:orange"></i>
        <span
          style="font-size: 18px;font-family: PingFang SC;font-weight: bold;line-height: 30px;color: #333333;margin-left: 12px;">删除拆单</span>
      </div>
      <div class="content" style="padding:20px 30px">
        <div style="font-size: 16px;margin-top: 20px;margin-left: 30px;">是否确认删除<span style="color:red">[订单拆单]{{
          this.dIndex + 1
        }}</span>，删除后不可恢复数据!</div>
        <div style="display: flex;justify-content: end;margin-top: 20px;margin-bottom: 10px;">
          <div class="cBtn" @click="isDelete = false">取消</div>
          <div class="qBtn" @click="cDeleterOrder()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import headerPicture from '@/components/upload/headerPicture.vue'
export default {
  components: {
    headerPicture
  },
  data() {
    return {
      orderId: '',
      orderNo: '',
      type: '0',
      totalAmount: 0.00,
      isContent: true,
      isDelete: false,
      value: true,
      checked1: true,
      isFinish: false,
      index: 0,
      dIndex: 0,
      dialogTableVisible: false,
      name: '---',
      qrCodeUrl: '',
      contact: '',
      dialogUser: false,
      splitOrderList: [

      ],
      selectGoods: [

      ],
      goods: [

      ],
      goodsCopy: [

      ],
      selectGoodsCopy: [

      ]
    }
  },
  created() {
    console.log(this.$route.query.orderId)
    this.orderId = this.$route.query.orderId
    this.type = this.$route.query.type || '0'
    this.orderNo = this.$route.query.orderNo || ''
    this.totalAmount = Number(this.$route.query.totalAmount).toFixed(2)
    this.getOrderGoods()
    this.getSplitOrderList()
  },
  methods: {
    getOrderGoods() {
      let params = {
        type: this.type,
        orderId: this.orderId,
      }
      this.axios.get('/neworder/order/split/getGoodsList', { params })
        .then(res => {
          if (res.code == 0) {
            this.goods = res.data || []
            this.goodsCopy = JSON.parse(JSON.stringify(this.goods))
          } else {
            this.$message.error(res.message)

          }
        })
    },
    getSplitOrderList() {
      let params = {
        type: this.type,
        orderId: this.orderId,
      }
      this.axios.get('/neworder/order/split/getChildList', { params })
        .then(res => {
          if (res.code == 0) {
            res.data.forEach(item => {
              item.collectAmount = item.collectionAmount
            })
            this.splitOrderList = res.data || []
          } else {
            this.$message.error(res.message)

          }
        })
    },
    cDeleterOrder() {
      this.splitOrderList.splice(this.dIndex, 1)
      this.handleOldDataNumD()
      this.isDelete = false
    },
    deleteOrder(index) {
      this.isDelete = true
      this.dIndex = index
    },
    upDateNum(e, index, sIndex, row) {
      console.log(e)
      if ((e == null || e == '') && (e !== 0)) {
        this.$message({
          type: 'error',
          message: '数量不能为空'
        })
        this.splitOrderList[index].goodsList[sIndex].quantity = 1
        this.handleOldDataNum()
        return
      } else if (e == 0) {
        this.$message({
          type: 'error',
          message: '数量不能为0'
        })
        this.splitOrderList[index].goodsList[sIndex].quantity = 1
        this.handleOldDataNum()
      }
      this.splitOrderList[index].goodsList[sIndex].quantity = e
      let tempArray = []
      for (let i = 0; i < this.splitOrderList.length; i++) {
        this.splitOrderList[i].goodsList.forEach(item => {
          item.quantity = Number(item.quantity)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      setArr.forEach(item => {
        this.goods.forEach(item1 => {
          if (item.orderGiftDetailId == item1.orderGiftDetailId && item.quantity > item1.quantity) {
            this.$message({
              type: 'error',
              message: '数量不能大于剩余量'
            })
            this.splitOrderList[index].goodsList[sIndex].quantity = 1
          }
        })

      })
      this.handleOldDataNum()
      this.$forceUpdate()
    },
    //处理更改后原始数据数量
    handleOldDataNum() {
      let tempArray = []
      for (let i = 0; i < this.splitOrderList.length; i++) {
        this.splitOrderList[i].goodsList.forEach(item => {
          item.quantity = Number(item.quantity)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      console.log(setArr)
      if (setArr.length != 0) {
        this.goods.forEach(item => {
          setArr.forEach(item1 => {
            if (item.orderGiftDetailId == item1.orderGiftDetailId) {
              item.splitQuantity = item1.quantity
            }
          })
        })
      } else {
        this.goods.forEach(item => {
          item.splitQuantity = 0
        })
      }

    },
    //删除后原始数据数量
    handleOldDataNumD() {
      let tempArray = []
      for (let i = 0; i < this.splitOrderList.length; i++) {
        this.splitOrderList[i].goodsList.forEach(item => {
          item.quantity = Number(item.quantity)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      console.log(setArr)
      if (setArr.length != 0) {
        // this.goods.forEach(item => {
        //   setArr.forEach(item1 => {
        //     if (item.orderGiftDetailId == item1.orderGiftDetailId) {
        //       item.splitQuantity = item1.quantity
        //     } else {
        //       item.splitQuantity = 0
        //     }
        //   })
        // })
        this.goods.forEach((item, index) => {
          const item1 = setArr.find(itm => itm.orderGiftDetailId == item.orderGiftDetailId)
          if (item1) {
            item.splitQuantity = item1.quantity
          } else {
            item.splitQuantity = 0
          }
        })
      } else {
        this.goods.forEach(item => {
          item.splitQuantity = 0
        })
      }

    },
    inputNum(e, index, row) {
      console.log(e)
      if (e > row.quantity) {
        this.$message({
          type: 'error',
          message: '数量不能大于剩余量'
        })
        this.selectGoods[index].splitQuantity = 1
      }
    },
    deleteD(index, dIndex) {
      this.splitOrderList[index].goodsList.splice(dIndex, 1)
      this.handleOldDataNumD()
    },
    add() {
      if (this.type == 0) {
        let No = this.splitOrderList.length + 1
        let obj = {
          orderNo: this.orderNo + 'X' + No,
          collectAmount: 0,
          goodsList: []
        }
        this.splitOrderList.push(obj)
      } else {
        let No = this.splitOrderList.length + 1
        let str = ''
        if (No < 10) {
          str = '0' + No
        } else {
          str = No
        }
        let obj = {
          orderNo: this.orderNo + '-' + str,
          collectAmount: 0,
          goodsList: []
        }
        this.splitOrderList.push(obj)
      }

    },
    //合并数组
    concatData(oldArr) {
      var temp = {};
      for (var i in oldArr) {
        var id = oldArr[i].orderGiftDetailId;
        if (temp[id]) {
          temp[id].quantity += oldArr[i].quantity;
        } else {
          temp[id] = oldArr[i]
        }
      }
      var newArr = [];
      for (var j in temp) {
        newArr.push(temp[j])
      }
      return newArr;
    },
    //处理数据
    handleData() {
      let tempArray = []
      for (let i = 0; i < this.splitOrderList.length; i++) {
        this.splitOrderList[i].goodsList.forEach(item => {
          item.quantity = Number(item.quantity)
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      for (let i = 0; i < setArr.length; i++) {
        this.selectGoods.forEach(item => {
          if (item.orderGiftDetailId == setArr[i].orderGiftDetailId) {
            console.log(item.quantity)
            item.quantity = item.quantity - setArr[i].quantity
          }
        })
      }
      console.log(this.selectGoods)
      this.selectGoods = this.selectGoods.filter(val => val.quantity > 0);
    },
    addShop(index) {
      console.log(index)
      this.dialogTableVisible = true
      this.index = index
      this.goods.forEach(item => {
        item.checked = false
      })
      this.selectGoodsCopy = this.goods
      this.selectGoods = JSON.parse(JSON.stringify(this.selectGoodsCopy))
      this.selectGoods.forEach(item => {
        item.checked = false
        item.splitQuantity = 1
      })
      console.log(this.splitOrderList, this.selectGoods)
      if (this.splitOrderList[this.index].goodsList.length == 0) {
        this.handleData()

      } else {
        this.handleData()
        this.splitOrderList[this.index].goodsList.forEach(item => {
          this.selectGoods = this.selectGoods.filter(val => val.orderGiftDetailId != item.orderGiftDetailId && val.quantity != 0);
        })
      }
    },
    save() {
      console.log(this.splitOrderList)

      this.selectGoods.forEach(item => {
        if (item.checked) {
          console.log(item)
          item.quantity = Number(item.splitQuantity)
          this.splitOrderList[this.index].goodsList.push(item)
        }
      })
      console.log(this.splitOrderList)
      let tempArray = []
      for (let i = 0; i < this.splitOrderList.length; i++) {
        this.splitOrderList[i].goodsList.forEach(item => {
          tempArray.push(item)
        })
      }
      console.log(tempArray)
      let setArr = this.concatData(JSON.parse(JSON.stringify(tempArray)))
      this.goods.forEach(item => {
        setArr.forEach(item1 => {
          if (item.orderGiftDetailId == item1.orderGiftDetailId) {
            item.splitQuantity = item1.quantity
          }
        })
      })
      this.dialogTableVisible = false

    },
    back() {
      this.$router.go(-1)
    },
    submit() {
      let goodsCount = 0
      let cGoodsCount = 0
      let totalAmount = 0
      this.goods.forEach(item => {
        if (item.quantity) {
          goodsCount += item.quantity
        }
      })
      this.splitOrderList.forEach(item => {
        item.goodsList.forEach(item1 => {
          cGoodsCount += item1.quantity
        })
        totalAmount += Number(item.collectAmount)
      })
      console.log(totalAmount, this.totalAmount)
      if (goodsCount != cGoodsCount) {
        this.isFinish = true
        this.isContent = true
      } else if (goodsCount == cGoodsCount && totalAmount != Number(this.totalAmount) && this.type == 0) {
        this.isFinish = true
        this.isContent = false
      } else {
        if (this.type == 0) {
          for (let i = 0; i < this.splitOrderList.length; i++) {
            this.splitOrderList[i].orderNo = this.orderNo + 'X' + (i + 1)
          }
        } else {
          for (let i = 0; i < this.splitOrderList.length; i++) {
            let No = i + 1
            let str = ''
            if (No < 10) {
              str = '0' + No
            } else {
              str = No
            }

            this.splitOrderList[i].orderNo = this.orderNo + '-' + str
          }


        }
        this.splitOrderList.forEach(item => {
          item.collectAmount = Number(item.collectAmount)
        })
        let data = {
          type: this.type,
          orderId: this.orderId,
          splitOrderList: this.splitOrderList,
        }
        this.axios.post('/neworder/order/split/saveOrderList', data).then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            this.$router.go(-1)
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      }


    }
  }
}
</script>
<style scoped>
::v-deep .el-dialog__body {
  padding: 0;
}

.splitType {
  width: 120px;
  height: 24px;
  background: #E3EDFF;
  opacity: 1;
  border-radius: 18px;
  line-height: 24px;
  text-align: center;
  color: #333333;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  margin-top: 8px;
  margin-left: 24px;
}

::v-deep .el-textarea__inner {
  padding: 7px 15px !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4168E7;
  border-color: #4168E7;
}

::v-deep .el-switch__core {
  width: 58px !important;
}

::v-deep .el-switch__label {
  position: absolute;
  /* display: none; */
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  right: 14px;
}

.cBtn1 {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
  background: #CCCCCC;
}

.cBtn {
  width: 120px;
  height: 36px;
  border: 1px solid #D9D9D9;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #999999;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}

.qBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.goodsItem {
  width: 600px;
  height: 84px;
  background: #ecf0fd;

  display: flex;
  margin-bottom: 16px;
}

.goodsItem-name {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
}

.goodsItem-sku {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #666666;
}

.aBtn {
  width: 120px;
  height: 36px;
  background: #4168E7;
  opacity: 1;
  border-radius: 4px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #FFFFFF;
  text-align: center;
  cursor: pointer;
}

.div1 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.dialog-search {
  display: flex;
  width: 46%;
  justify-content: space-between;
  margin-top: 10px;
  margin-left: 10px;
}
</style>
  
  